import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Scroll } from '@angular/router';
import { UserProfile } from 'app/services/user.service';
import { routes } from 'app/modules/core/constants/core.constants';
import { getThumb } from '@shared/utility/helperMethods';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnChanges {
  @Input() rightStateSidebar = false;
  @Input() currentUser: UserProfile;
  @Output() rightSidebarChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() logedout: EventEmitter<string> = new EventEmitter<string>();

  cinicoTitle = 'Cinico';
  isProfileHidden = false;
  profileImage: string = 'assets/images/user-no-photo.png';

  // used as flag for mapping navigation links when scroll event is fired first time (on reload) and route is already "claims" or "quotes"
  onReloadPage = true;
  // used as flag for mapping navigation links back, after route changes and is not "claims" or "quotes"
  firstAfterChanged = true;

  toolbarNavigation: {
    routeLink: string;
    routeName: string;
    hidden: boolean;
  }[];

  constructor(private _router: Router) {
    this.toolbarNavigation = [
      {
        routeLink: '/dashboard',
        routeName: 'dashboard',
        hidden: false
      },
      {
        routeLink: '/policy',
        routeName: 'policy',
        hidden: false
      },
      {
        routeLink: '/payments',
        routeName: 'payments',
        hidden: false
      },
      {
        routeLink: '/claims',
        routeName: 'claims',
        hidden: false
      }
    ];
  }

  ngOnInit(): void {
    this._router.events
      .pipe(
        filter(event => {
          if (this.onReloadPage && event instanceof Scroll) {
            this.onReloadPage = false;
            return true;
          }

          return event instanceof NavigationEnd;
        }),
        map(value => (value instanceof NavigationEnd ? value.url : (value as Scroll).routerEvent.url))
      )
      .subscribe(url => {
        this.isProfileHidden = this.shouldHideProfile(url);

        if (this.isProfileHidden) {
          if (this.firstAfterChanged) {
            this.firstAfterChanged = false;
            this.toolbarNavigation.map(
              item => (item.hidden = item.routeName != routes.dashboard ? this.isProfileHidden : false)
            );
          }
        } else {
          if (!this.firstAfterChanged) {
            this.firstAfterChanged = true;
            this.toolbarNavigation.map(
              item => (item.hidden = item.routeName != routes.dashboard ? this.isProfileHidden : false)
            );
          }
        }
      });

    this.updateProfileImage();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentUser']) {
      this.updateProfileImage();
    }
  }

  updateProfileImage() {
    this.profileImage = this.currentUser?.profileImage ? getThumb(40, 40, this.currentUser?.profileImage) : 'assets/images/user-no-photo.png';
  }

  shouldHideProfile(url: string) {
    const checkUrl =
      (url.includes('claims/') || url.includes('quotes/') || url.includes('success-message')) &&
      !url.includes('claims/claim-details');
    return checkUrl;
  }

  toggleRightSidebar(state: boolean) {
    this.rightSidebarChange.emit(state);
  }

  logout() {
    this.logedout.emit();
  }
}
